
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/webinar",
      function () {
        return require("private-next-pages/pelatihan-mandiri/webinar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri/webinar"])
      });
    }
  